<template>
  <div class="svg-icon flex flex-none items-center justify-center" :class="svgClass">
    <component :is="dynamicComponent" />
  </div>
</template>

<script setup lang="ts">
import type { IconName } from '@/types/icon'

interface Props {
  name: IconName
  color?: string
}

const props = withDefaults(defineProps<Props>(), { color: '' })

const svgClass = computed(() => ({
  [`text-${props.color}`]: !!props.color,
}))
const assetName = computed(() => `icons/${props.name}.svg`)

const dynamicComponent = useAsset(assetName)
</script>
